import React, { useMemo } from 'react';

import { splitCopticRuns } from '../../utils/hieroglyphReading';

// Shared by HieroglyphCard and KamaGuideCard (the .hgw__coptic font rule
// lives in HieroglyphCard.css).
// Prose fields (translation, reading, leadSignNote, quiz text) routinely
// embed a Coptic word mid-sentence — wraps just those runs in a font
// verified to cover Coptic's two disjoint Unicode ranges (see
// splitCopticRuns), leaving the surrounding French text untouched.
export const CopticText: React.FC<{ text?: string }> = ({ text }) => {
  const segments = useMemo(() => splitCopticRuns(text ?? ''), [text]);
  if (!text) return null;
  return (
    <>
      {segments.map((seg, i) => (seg.coptic ? (
        <span key={i} className="hgw__coptic">{seg.text}</span>
      ) : (
        <React.Fragment key={i}>{seg.text}</React.Fragment>
      )))}
    </>
  );
};

export default CopticText;
